import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const detail = err.response?.data?.detail || "";
    if (err.response?.status === 403 && /read-only/i.test(detail)) {
      toast.error("You have read-only access — changes aren't permitted.");
    } else if (err.response?.status === 403 && /plan limit reached/i.test(detail)) {
      toast.error(detail);
    } else if (err.response?.status === 402) {
      toast.error(detail || "Your free trial has ended — subscribe to continue.");
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/billing")) {
        setTimeout(() => window.location.assign("/billing"), 900);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
